import * as React from "react";
import { Dispatch, SetStateAction } from "react";
import { PbrSelect } from "src/components/common/PbrSelect/PbrSelect";
import { Select, Col, Row } from "antd";
import { FormComponentProps } from "antd/lib/form";
import { PbrCard } from "src/components/common/PbrCard/PbrCard";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { IBankOwner } from "src/services/interfaces/trade/tradeOwner/IBankOwner";
import { TradeAccountTypeEnum } from "src/components/common/BankInfo/TradeAccountTypeEnum";
import { SelectBankName } from 'src/components/common/SelectBankName/SelectBankName';
import { PbrInputNumbers } from '../../PbrInputNumbers/PbrInputNumbers';

interface IEditTradeBankInfoProps extends FormComponentProps {
  trade: ITrade;
  setTrade: Dispatch<SetStateAction<ITrade>>;
  title: string;
  isBankInfoRequired: boolean
}

export const EditTradeBankInfo: React.FC<IEditTradeBankInfoProps> = ({
  trade,
  setTrade,
  title,
  form,
  isBankInfoRequired
}) => {
  const handleBankChange = (value: Partial<IBankOwner>) => {

    const bankData = { ...trade.tradeOwner?.bankData, ...value } as IBankOwner;
    setTrade({
      ...trade,
      tradeOwner: { ...trade.tradeOwner, bankData }
    });
  };

  function changeBank(e: string) {
    handleBankChange({ bank: e });
  }

  return (
    <PbrCard className="default-tabs" title={title} bordered={false} style={{ width: "100%" }}>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={12} lg={12}>
          <SelectBankName onChange={changeBank} bankData={trade.tradeOwner?.bankData} form={form} isBankRequired />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <PbrSelect
            name="accountType"
            size="large"
            formItemProps={{ label: "Tipo da conta" }}
            formWrapper={form}
            showSearch
            value={trade.tradeOwner?.bankData?.accountType}
            onChange={e => handleBankChange({ accountType: e as TradeAccountTypeEnum })}
            placeholder="Selecione o tipo da conta"
            rules={[{ required: isBankInfoRequired, message: "Informe o o tipo da conta" }]}
          >
            <Select.Option key={TradeAccountTypeEnum.Corrente} value={TradeAccountTypeEnum.Corrente}>
              Corrente
            </Select.Option>
            <Select.Option key={TradeAccountTypeEnum.Poupanca} value={TradeAccountTypeEnum.Poupanca}>
              Poupança
            </Select.Option>
          </PbrSelect>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={24} md={12} lg={12}>
          <PbrInputNumbers
            name="agency"
            value={trade.tradeOwner?.bankData?.agency}
            title="Agência (sem dígito)"
            formWrapper={form}
            rules={[
              { required: true, message: "A agência é obrigatório" },
              { min: 4, max: 4, message: "A agência deve ter 4 dígitos" }]}
            onChange={value => handleBankChange({ agency: value.trim() })}
          />
        </Col>
        <Col xs={24} sm={24} md={8} lg={8}>
          <PbrInputNumbers
            name="account"
            value={trade.tradeOwner?.bankData?.account}
            title="Conta"
            formWrapper={form}
            rules={[{ required: true, message: "A conta é obrigatória" }]}
            onChange={value => handleBankChange({ account: value.trim() })}
          />
        </Col>
        <Col xs={24} sm={24} md={4} lg={4}>
          <PbrInputNumbers
            name="accountDigit"
            value={trade.tradeOwner?.bankData?.accountDigit}
            title="Dígito"
            formWrapper={form}
            rules={[
              { required: true, message: "O dígito é obrigatório" },
              { max: 2, message: "O dígito da conta não deve ser maior que 2 dígitos" }
            ]}
            onChange={value => handleBankChange({ accountDigit: value.trim() })}
          />
        </Col>
      </Row>
    </PbrCard>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/TradeEdit/EditBankInfo/EditTradeBankInfo.tsx